import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-center"
}
const _hoisted_2 = { class: "w-100 mt-3 text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_datalist = _resolveComponent("b-form-datalist")!
  const _component_CommonButton = _resolveComponent("CommonButton")!

  return (_ctx.isBusy)
    ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("label", { for: "input-with-list" }, null, -1)),
        _createVNode(_component_b_form_input, {
          list: "input-list",
          id: "input-with-list",
          modelValue: _ctx.selectedItem,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItem) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_b_form_datalist, {
          id: "input-list",
          options: _ctx.dropdownList
        }, null, 8, ["options"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_CommonButton, {
            type: _ctx.ButtonType.Primary,
            text: _ctx.Localizer.Localize('Select'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.SetItem(true)))
          }, null, 8, ["type", "text"])
        ])
      ]))
}